import React from "react";
import PropTypes from "prop-types";

import { availableLocales } from "../lng/Locales";

import { validateEmail, validateCheckOnlyModified } from "./SettingsValue";
import BoolControl from "./BoolControl";
import SelectControl, { SelectOption } from "./SelectControl";
import StringControl from "./StringControl";

const EmailReceiver = props => (
	<form>
		<BoolControl i18n_key="Receiver active" prop="active"
			local={props.receiver} handleChange={props.handleChange} />
		<StringControl i18n_key="E-mail address" prop="email_address"
			validate={validateEmail} local={props.receiver} handleChange={props.handleChange} />
		<SelectControl i18n_key="Language" prop="language"
			local={props.receiver} handleChange={props.handleChange}>
			{availableLocales.map((locale, index) => (
				<SelectOption key={index} value={locale.locale} i18n_key={locale.i18n_key} />
			))}
		</SelectControl>
		<BoolControl i18n_key="Send maintenance" prop="send_maintenance"
			local={props.receiver} handleChange={props.handleChange} />
		<BoolControl i18n_key="Send warnings" prop="send_warnings"
			local={props.receiver} handleChange={props.handleChange} />
		<BoolControl i18n_key="Send errors" prop="send_errors"
			local={props.receiver} handleChange={props.handleChange} />
		<StringControl i18n_key="Salutation" prop="salutation"
			validate={validateCheckOnlyModified} local={props.receiver} handleChange={props.handleChange} />
		<StringControl i18n_key="Plant address" prop="plant_address"
			validate={validateCheckOnlyModified} local={props.receiver} handleChange={props.handleChange} />
	</form>
);

EmailReceiver.propTypes = {
	receiver: PropTypes.object.isRequired,
	handleChange: PropTypes.func.isRequired
};

export default EmailReceiver;
